"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddVoucherEvent = void 0;
const Name = exports.Name = 'add-voucher';
const AddVoucherEvent = exports.AddVoucherEvent = Name;
//# sourceMappingURL=index.js.map